module.exports = __webpack_public_path__ + "static/media/icon-ln-lblue.af44916d.svg";